import configureStore from '../store/ConfigureStore'
import combinedReducers from '../reducers/Index'

const store = configureStore(combinedReducers);

export default store;
